<div class="custom-select" [ngClass]="{'disabled':disabled, 'required':required}">
	<label [ngClass]="{'disabled':disabled}">{{caption}}</label>
	<select [required]="required"
	        [disabled]="disabled"

	        [ngModel]="value"

	        (ngModelChange)="change($event)"
	        (keydown)="onKeyPress($event)">
		<option *ngFor="let value of list;let i = index" [value]="i">
			<ng-container *ngIf="dateDisplay; else standardDisplay">
				{{displayItem(value) | excDate: dateFormat}}
			</ng-container>
			<ng-template #standardDisplay>{{displayItem(value)}}</ng-template>
		</option>
	</select>
	<span class="custom-arrow" [ngClass]="{'disabled':disabled}"><i class="fa fa-fw fa-chevron-down"></i></span>
</div>
